/**
 * D431 step 5: a swatch in a theme's own accent with its world-tab icon, for the first run's
 * cards and the worlds list. The accent comes from the theme's tokens (`data-world`, and
 * `data-theme` too in dark mode, since the dark accents are set on both together), so a card
 * for one theme shows its colour whichever world is open.
 */
import { getIdleContent } from '@hedgerow/data';
import { hasSpriteIcon, Icon } from '../ui/Icon.tsx';

/** The world tab's icon in a theme: its own where drawn, the plot otherwise. */
export function worldTabIconFor(theme: string | undefined): string {
  const word = getIdleContent(theme).terms.tabWorld;
  const own = `tabs_${word.toLowerCase().replace(/[^a-z0-9]/g, '')}`;
  return hasSpriteIcon(own) ? own : 'land-plot';
}

export function ThemeSwatch({
  theme,
  size = 44,
  icon = 22,
}: {
  theme: string | undefined;
  size?: number;
  icon?: number;
}) {
  const dark =
    typeof document !== 'undefined' &&
    document.documentElement.getAttribute('data-theme') === 'dark';
  return (
    <span
      aria-hidden="true"
      data-world={theme ?? 'farm'}
      {...(dark ? { 'data-theme': 'dark' } : {})}
      style={{
        flex: 'none',
        width: size,
        height: size,
        borderRadius: 8,
        display: 'grid',
        placeItems: 'center',
        background: 'var(--accent)',
        color: 'var(--accent-ink)',
      }}
    >
      <Icon name={worldTabIconFor(theme)} size={icon} />
    </span>
  );
}
